
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.5 15.8333C1.5 16.2935 1.8731 16.6666 2.33333 16.6666C2.79357 16.6666 3.16667 16.2935 3.16667 15.8333L3.16667 4.16659C3.16667 3.70635 2.79357 3.33325 2.33333 3.33325C1.8731 3.33325 1.5 3.70635 1.5 4.16659L1.5 15.8333ZM10.9107 3.57733C11.2362 3.25189 11.7638 3.25189 12.0893 3.57733C12.4147 3.90277 12.4147 4.4304 12.0893 4.75584L7.67851 9.16659L19 9.16659C19.4602 9.16659 19.8333 9.53968 19.8333 9.99992C19.8333 10.4602 19.4602 10.8333 19 10.8333L7.67851 10.8333L12.0893 15.244C12.4147 15.5694 12.4147 16.0971 12.0893 16.4225C11.7638 16.7479 11.2362 16.7479 10.9107 16.4225L5.07741 10.5892C4.75198 10.2637 4.75198 9.7361 5.07741 9.41066L10.9107 3.57733Z","fill":"#16171F"}})])
          )
        }
      }
    